import { shade } from 'polished'
import luxuryEscapesTheme, { luxuryEscapesBorderRadii, luxuryEscapesDefaultPalette, luxuryEscapesInversePalette } from './luxuryescapes'
import { OCEAN } from './primitiveColours'
import { baseThemeShadows } from './shadows'

export const leBusinessTravellerDefaultPalette: App.Design.Palette<string> = {
  ...luxuryEscapesDefaultPalette,
  highlight: {
    ...luxuryEscapesDefaultPalette.highlight,
    primary: {
      ...luxuryEscapesDefaultPalette.highlight.primary,
      darkForeground: OCEAN[700],
      darkBackground: OCEAN[700],
      darkActive: shade(0.24, OCEAN[700]),
    },
  },
}

export const leBusinessTravellerInversePalette: App.Design.Palette<string> = {
  ...luxuryEscapesInversePalette,
  highlight: {
    ...luxuryEscapesInversePalette.highlight,
    primary: {
      ...luxuryEscapesInversePalette.highlight.primary,
      darkForeground: OCEAN[400],
      darkBackground: OCEAN[700],
      darkActive: shade(0.24, OCEAN[700]),
    },
  },
}

export const leBusinessTravellerShadows: App.Design.Shadows<string> = { ...baseThemeShadows }
export const leBusinessTravellerBorderRadii: App.Design.BorderRadii<string> = { ...luxuryEscapesBorderRadii }

const leBusinessTravellerTheme: App.Design.Theme = {
  ...luxuryEscapesTheme,
}

export default leBusinessTravellerTheme
